import type { Locale } from "@chams-pay/contracts";
import { documentMessages, translate } from "@chams-pay/contracts";

export function ReceiptLanguageSwitch({
  locale,
  value,
  onChange,
  showLabel = true,
}: {
  readonly locale: Locale;
  readonly value: Locale;
  readonly onChange: (locale: Locale) => void;
  readonly showLabel?: boolean;
}) {
  const documentText = documentMessages(value);

  return (
    <div className={`flex flex-col ${showLabel ? "gap-2.5" : ""}`}>
      {showLabel && (
        <span className="chams-eyebrow">{translate(locale, "ops.receiptLanguage")}</span>
      )}
      <div
        role="tablist"
        aria-label={translate(locale, "ops.receiptLanguage")}
        data-tab-count="2"
        data-active-index={value === "ar" ? "0" : "1"}
        className="receipt-language sliding-tabs no-print flex gap-[3px] overflow-hidden rounded-lg bg-sunken p-[3px]"
      >
        <span className="sliding-tabs__indicator" aria-hidden="true" />
        {(["ar", "fr"] as const).map((language) => {
          const active = value === language;
          return (
            <button
              key={language}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(language)}
              className="h-11 min-h-11 flex-1 rounded-md font-heading text-xs font-bold"
            >
              {language === "ar" ? documentText.arabic : documentText.french}
            </button>
          );
        })}
      </div>
    </div>
  );
}
